import { Pipe, type PipeTransform } from '@angular/core'
import { DomSanitizer, type SafeUrl } from '@angular/platform-browser'

@Pipe({
  name: 'DOMSafeUrl',
  pure: true
})
export class DOMSafeUrlPipe implements PipeTransform {
  constructor (private readonly sanitizer: DomSanitizer) {}

  public transform (url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }
}
